import React from 'react'

export default function FooterCube(props) {
  return (
    <svg width={263} height={258} viewBox="0 0 263 258" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#343734" d="M132 129L1.726 176.77l-.058.329 107.758 79.926 128.596-38.25.057-.329z" />
        <path
          d="M154.574.975L24.821 45.791 1.668 177.1l107.758 79.926 128.596-38.25 23.153-131.308L154.575.975zm106.6 86.492L132 129 24.82 45.791m213.202 172.983L132 129 1.668 177.099"
          stroke="#343734"
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
